export const words = [
    "ARMOIRE",
    "BUREAU",
    "CABINET",
    "CARREAU",
    "CHAISE",
    "CLASSE",
    "COULOIR",
    "DOSSIER",
    "ECRITURE",
    "ENTREE",
    "ESCALIER",
    "ETAGERE",
    "EXTERIEUR",
    "FENETRE",
    "INTERIEUR",
    "LAVABO",
    "LECTURE",
    "MARCHE",
    "MATELAS",
    "MEUBLE",
    "MOUSSE",
    "PELUCHE",
    "PLACARD",
    "PLAFOND",
    "POUBELLE",
    "RADIATEUR",
    "RENTREE",
    "RIDEAU",
    "ROBINET",
    "SERRURE",
    "SERVIETTE",
    "SIESTE",
    "SILENCE",
    "SOMMEIL",
    "SONNETTE",
    "SORTIE",
    "TABLEAU",
    "TABOURET",
    "TIROIR",
    "TOILETTE",
    "AMENER",
    "APPORTER",
    "APPUYER",
    "ASSEOIR",
    "ATTENDRE",
    "BAILLER",
    "BOSSER",
    "COUCHER",
    "DORMIR",
    "ECLAIRER",
    "ECRIRE",
    "EMMENER",
    "EMPORTER",
    "ENNUYER",
    "ENTRER",
    "ETUDIER",
    "FERMER",
    "FRAPPER",
    "OUVRIR",
    "PRESSER",
    "RENTRER",
    "REPOSER",
    "RESTER",
    "REVEILLER",
    "SONNER",
    "SORTIR",
    "TRICHER",
    "ABSENT",
    "COUCHE",
    "PRESENT",
    "DROITE",
    "GAUCHE",
    "MILIEU",
    "DEBOUT",
    "DEDANS",
    "DEHORS",
    "CONTRE",
    "DERRIERE",
    "DEVANT",
    "TRAVAIL",
    "COMPLET",
    "CRAYON",
    "FEUTRE",
    "POINTE",
    "DESSIN",
    "COLORIAGE",
    "RAYURE",
    "PEINTURE",
    "PINCEAU",
    "COULEUR",
    "PAPIER",
    "FEUILLE",
    "CAHIER",
    "CARNET",
    "CARTON",
    "CISEAUX",
    "DECOUPAGE",
    "PLIAGE",
    "AFFAIRE",
    "CASIER",
    "CAISSE",
    "TROUSSE",
    "CARTABLE",
    "DOMINO",
    "PUZZLE",
    "MODELER",
    "TAMPON",
    "HISTOIRE",
    "DESSINEE",
    "MAGAZINE",
    "CATALOGUE",
    "ENVELOPPE",
    "ETIQUETTE",
    "AFFICHE",
    "ALPHABET",
    "APPAREIL",
    "CAMESCOPE",
    "CASSETTE",
    "CEDEROM",
    "CHAINE",
    "CHANSON",
    "CHIFFRE",
    "CONTRAIRE",
    "INTRUS",
    "LETTRE",
    "MODELE",
    "MUSIQUE",
    "NOMBRE",
    "ORCHESTRE",
    "POSTER",
    "PRENOM",
    "TAMBOUR",
    "TELEPHONE",
    "TROMPETTE",
    "CHANTER",
    "CHERCHER",
    "CHOISIR",
    "CHUCHOTER",
    "COLLER",
    "COLORIER",
    "COMMENCER",
    "COMPARER",
    "COMPTER",
    "CONTINUER",
    "COPIER",
    "COUPER",
    "DECHIRER",
    "DECOLLER",
    "DECORER",
    "DECOUPER",
    "DEMANDER",
    "DEMOLIR",
    "DEPECHER",
    "DESSINER",
    "DISCUTER",
    "ECOUTER",
    "EFFACER",
    "ENTENDRE",
    "ENTOURER",
    "ENVOYER",
    "FOUILLER",
    "GOUTER",
    "IMITER",
    "LAISSER",
    "METTRE",
    "MONTRER",
    "PARLER",
    "PEINDRE",
    "PRENDRE",
    "PREPARER",
    "RANGER",
    "RECITER",
    "REGARDER",
    "REMETTRE",
    "REPETER",
    "REPONDRE",
    "SENTIR",
    "SOULIGNER",
    "TAILLER",
    "TERMINER",
    "TOUCHER",
    "AUTRES",
    "ATTENTION",
    "CAMARADE",
    "COLERE",
    "COPAIN",
    "COQUIN",
    "DIRECTEUR",
    "EFFORT",
    "ENFANT",
    "FATIGUE",
    "GARCON",
    "GARDIEN",
    "MADAME",
    "MAITRE",
    "MAITRESSE",
    "MENSONGE",
    "PERSONNE",
    "RETARD",
    "SOURIRE",
    "DEFENDRE",
    "DESOBEIR",
    "ECHANGER",
    "EXCUSER",
    "EXPLIQUER",
    "FACHER",
    "GRONDER",
    "OBLIGER",
    "PARTAGER",
    "PRETER",
    "PRIVER",
    "PROMETTRE",
    "RACONTER",
    "REFUSER",
    "SEPARER",
    "CURIEUX",
    "DIFFERENT",
    "ENERVE",
    "GENTIL",
    "HANDICAPE",
    "JALOUX",
    "NOUVEAU",
    "PROPRE",
    "SERIEUX",
    "ARROSOIR",
    "ASSIETTE",
    "BATEAU",
    "BOUCHON",
    "BOUTEILLE",
    "BULLES",
    "CANARD",
    "CASSEROLE",
    "CUILLERE",
    "CUVETTE",
    "DOUCHE",
    "ENTONNOIR",
    "GOUTTES",
    "MOULIN",
    "POISSON",
    "PLASTIQUE",
    "SALADIER",
    "TABLIER",
    "AGITER",
    "AMUSER",
    "ARROSER",
    "ATTRAPER",
    "AVANCER",
    "BAIGNER",
    "BARBOTER",
    "BOUCHER",
    "BOUGER",
    "DEBORDER",
    "DOUCHER",
    "ESSUYER",
    "FLOTTER",
    "GONFLER",
    "INONDER",
    "MELANGER",
    "MOUILLER",
    "PATAUGER",
    "PLEUVOIR",
    "PLONGER",
    "POUSSER",
    "POUVOIR",
    "RECEVOIR",
    "REMPLIR",
    "RENVERSER",
    "SECHER",
    "SERRER",
    "SOUFFLER",
    "TOURNER",
    "TREMPER",
    "VERSER",
    "VOULOIR",
    "AMUSANT",
    "HUMIDE",
    "MOUILLE",
    "MOITIE",
    "AUTANT",
    "BEAUCOUP",
    "ENCORE",
    "ENVERS",
    "ANORAK",
    "BAGAGE",
    "BAGUETTE",
    "BONNET",
    "BOUTON",
    "BRETELLE",
    "CAGOULE",
    "CASQUE",
    "CASQUETTE",
    "CEINTURE",
    "CHAPEAU",
    "CHAUSSON",
    "CHAUSSURE",
    "CHEMISE",
    "CIGARETTE",
    "COLLANT",
    "COURONNE",
    "CRAVATE",
    "CULOTTE",
    "ECHARPE",
    "FLECHE",
    "LUNETTES",
    "MAGICIEN",
    "MAILLOT",
    "MANCHE",
    "MANTEAU",
    "MOUCHOIR",
    "MOUFLE",
    "PANTALON",
    "PRINCE",
    "PYJAMA",
    "SEMELLE",
    "SOLDAT",
    "SORCIERE",
    "TAILLE",
    "TRICOT",
    "UNIFORME",
    "VALISE",
    "VETEMENT",
    "CHANGER",
    "CHAUSSER",
    "COUVRIR",
    "DEGUISER",
    "ENLEVER",
    "PORTER",
    "ETROIT",
    "PRESQUE",
    "BRICOLAGE",
    "AIGUILLE",
    "AMPOULE",
    "CABANE",
    "CROCHET",
    "ELASTIQUE",
    "FICELLE",
    "MARTEAU",
    "MORCEAU",
    "MOTEUR",
    "PLANCHE",
    "PLATRE",
    "TOURNEVIS",
    "VOITURE",
    "VEHICULE",
    "ARRACHER",
    "ATTACHER",
    "CASSER",
    "COUDRE",
    "DETRUIRE",
    "ENFILER",
    "ENFONCER",
    "FABRIQUER",
    "MESURER",
    "PERCER",
    "PINCER",
    "REPARER",
    "REUSSIR",
    "SERVIR",
    "TROUER",
    "ADROIT",
    "DIFFICILE",
    "FACILE",
    "MALADROIT",
    "POINTU",
    "RUGUEUX",
    "ACCIDENT",
    "AEROPORT",
    "CAMION",
    "GARAGE",
    "PARKING",
    "PILOTE",
    "VIRAGE",
    "VITESSE",
    "VOYAGE",
    "ARRETER",
    "ATTERRIR",
    "BOUDER",
    "CHARGER",
    "CONDUIRE",
    "DEMARRER",
    "DONNER",
    "ECRASER",
    "ENVOLER",
    "GARDER",
    "MANQUER",
    "PARTIR",
    "RECULER",
    "ROULER",
    "TENDRE",
    "ANCIEN",
    "DERNIER",
    "DEUXIEME",
    "PAREIL",
    "PREMIER",
    "SOLIDE",
    "TROISIEME",
    "AUTOUR",
    "ACROBATE",
    "ARRIERE",
    "BARREAU",
    "CERCEAU",
    "CHAISES",
    "CHEVILLE",
    "CUISSE",
    "DANGER",
    "DOIGTS",
    "ECHASSES",
    "ECHELLE",
    "EPAULE",
    "EQUIPE",
    "ESCABEAU",
    "HANCHE",
    "JAMBES",
    "MONTAGNE",
    "MUSCLE",
    "NUMERO",
    "PARCOURS",
    "PLONGEOIR",
    "POIGNET",
    "POUTRE",
    "PRISES",
    "RIVIERE",
    "ROULADE",
    "SERPENT",
    "SUIVANT",
    "TOBOGGAN",
    "TUNNEL",
    "VENTRE",
    "ARRIVER",
    "BAISSER",
    "BALANCER",
    "BONDIR",
    "BOUSCULER",
    "COGNER",
    "COURIR",
    "DANSER",
    "DEPASSER",
    "DESCENDRE",
    "ECARTER",
    "ESCALADER",
    "GAGNER",
    "GLISSER",
    "GRIMPER",
    "MARCHER",
    "PATTES",
    "MONTER",
    "PENCHER",
    "PERCHER",
    "PERDRE",
    "RAMPER",
    "REMPLACER",
    "RESPIRER",
    "RETOURNER",
    "REVENIR",
    "SAUTER",
    "SOULEVER",
    "SUIVRE",
    "TOMBER",
    "TRAVERSER",
    "DANGEREUX",
    "GROUPE",
    "IMMOBILE",
    "SOUPLE",
    "ENSEMBLE",
    "JAMAIS",
    "SOUVENT",
    "TOUJOURS",
    "BAGARRE",
    "BALLON",
    "CADENAS",
    "ECUREUIL",
    "CHATEAU",
    "COURSE",
    "ECHASSE",
    "FLAQUE",
    "PARDON",
    "PARTIE",
    "PEDALE",
    "RAQUETTE",
    "SIFFLET",
    "TRICYCLE",
    "BAGARRER",
    "BATTRE",
    "CACHER",
    "CRACHER",
    "CREUSER",
    "DEGONFLER",
    "DISPUTER",
    "EMPECHER",
    "GALOPER",
    "HURLER",
    "JONGLER",
    "LANCER",
    "PEDALER",
    "PLAINDRE",
    "PLEURER",
    "PROTEGER",
    "SAIGNER",
    "SIFFLER",
    "TRAINER",
    "TROUVER",
    "MECHANT",
    "CUISINE",
    "GATEAUX",
    "CREPES",
    "ALLUMETTE",
    "APPETIT",
    "BEURRE",
    "COQUILLE",
    "CROUTE",
    "DESSERT",
    "GALETTE",
    "GATEAU",
    "LANGUE",
    "LEVRES",
    "LIQUIDE",
    "LOUCHE",
    "RECETTE",
    "ROULEAU",
    "TRANCHE",
    "ALLUMER",
    "AVALER",
    "BRULER",
    "CHAUFFER",
    "ETALER",
    "ETEINDRE",
    "FALLOIR",
    "INVITER",
    "LECHER",
    "OUBLIER",
    "REGALER",
    "REMERCIER",
    "REMUER",
    "SOUHAITER",
    "ENTIER",
    "GOURMAND",
    "MAUVAIS",
    "MEILLEUR",
    "SALADE",
    "FRUITS",
    "GLACON",
    "PAILLE",
    "CROQUER",
    "EPLUCHER",
    "LEGUMES",
    "BASSINE",
    "COCOTTE",
    "EPLUCHURE",
    "LEGUME",
    "RONDELLE",
    "CONSOMME",
    "POTAGE",
    "BOUILLIR",
    "CANTINE",
    "GOBELET",
    "JAMBON",
    "POULET",
    "DEJEUNER",
    "ANIMAUX",
    "ANIMAL",
    "BOUCHE",
    "CARESSE",
    "COCHON",
    "GRAINES",
    "HAMSTER",
    "MAISON",
    "OREILLE",
    "ACCOUCHER",
    "AGACER",
    "APPELER",
    "CALINER",
    "CARESSER",
    "DERANGER",
    "ELEVER",
    "ENFERMER",
    "ENTERRER",
    "GRATTER",
    "GRIGNOTER",
    "INSTALLER",
    "LACHER",
    "MORDRE",
    "MOURIR",
    "NAITRE",
    "NOURRIR",
    "OCCUPER",
    "PROMENER",
    "RONGER",
    "SAUVER",
    "SOIGNER",
    "ABANDONNE",
    "ENCEINTE",
    "MAIGRE",
    "VIVANT",
    "ABEILLE",
    "AGNEAU",
    "BARQUE",
    "BASSIN",
    "BOUQUET",
    "BOURGEON",
    "BRANCHE",
    "CAILLOU",
    "CAMPAGNE",
    "CHARIOT",
    "CHEMINEE",
    "CHEVAL",
    "CHEVRE",
    "COLLINE",
    "CRAPAUD",
    "DEPART",
    "DINDON",
    "ESCARGOT",
    "FERMIER",
    "FLAMME",
    "FONTAINE",
    "GRAINE",
    "GRIFFE",
    "HERISSON",
    "INSECTE",
    "JARDIN",
    "MOUCHE",
    "MOUTON",
    "OISEAU",
    "PIERRE",
    "PIGEON",
    "PLANTE",
    "POUSSIN",
    "PRAIRIE",
    "TORTUE",
    "TRACTEUR",
    "TULIPE",
    "COUVER",
    "MANGER",
    "GRIFFER",
    "HABITER",
    "PIQUER",
    "RAMASSER",
    "TRAIRE",
    "BIZARRE",
    "ENORME",
    "IMMENSE",
    "MALADE",
    "AQUARIUM",
    "CHOUETTE",
    "CIGOGNE",
    "CROCODILE",
    "DAUPHIN",
    "ELEPHANT",
    "GIRAFE",
    "PANTHERE",
    "PERROQUET",
    "PHOQUE",
    "RENARD",
    "REQUIN",
    "CARNAVAL",
    "EPINGLE",
    "BETISE",
    "BONHOMME",
    "BOTTES",
    "CAUCHEMAR",
    "DINOSAURE",
    "DRAPEAU",
    "ARGENT",
    "FIGURE",
    "JOURNAUX",
    "MASQUE",
    "MONSIEUR",
    "MOUSTACHE",
    "PRINCESSE",
    "TROTTOIR",
    "DEFILER",
    "ECLATER",
    "ESSAYER",
    "MOQUER",
    "PLAIRE",
    "CONTENT",
    "EFFRAYE",
    "HEUREUX",
    "JOYEUX",
    "TERRIBLE",
    "CADEAU",
    "CHANCE",
    "GUIRLANDE",
    "HUMEUR",
    "PAPILLON",
    "SPECTACLE",
    "SURPRISE",
    "VISAGE",
    "MAQUILLER",
    "DIMANCHE",
    "ETOILE",
    "MAMANS",
    "HORLOGE",
    "JOURNEE",
    "LUMIERE",
    "MERCREDI",
    "MINUIT",
    "MINUTE",
    "MOMENT",
    "MONTRE",
    "PENDULE",
    "RETOUR",
    "REVEIL",
    "SAISON",
    "SAMEDI",
    "SEMAINE",
    "SOLEIL",
    "UNIVERS",
    "VACANCES",
    "VENDREDI",
    "BRILLER",
    "GRANDIR",
    "RETARDER",
    "PATIENT",
    "RAPIDE",
    "SOMBRE",
    "BIENTOT",
    "DEMAIN",
    "AVANCE",
    "ECLAIR",
    "FLOCON",
    "GOUTTE",
    "OURAGAN",
    "PARAPLUIE",
    "PARASOL",
    "TEMPETE",
    "TONNERRE",
    "TRAINEAU",
    "ABRITER",
    "NEIGER",
    "TROMPER",
    "VENTER",
    "TRISTE",
    "PLUVIEUX",
    "NUAGEUX",
    "INSTABLE",
    "CHANGEANT",
    "BISCUIT",
    "BOISSON",
    "BONBON",
    "CEREALE",
    "CONFITURE",
    "COQUETIER",
    "COUTEAU",
    "COUVERCLE",
    "COUVERT",
    "DESORDRE",
    "DINETTE",
    "EPONGE",
    "LESSIVE",
    "MACHINE",
    "PLATEAU",
    "TARTINE",
    "TORCHON",
    "VAISSELLE",
    "ACCROCHER",
    "BALAYER",
    "FROTTER",
    "NETTOYER",
    "CUISINER",
    "DELICIEUX",
    "CHAMBRE",
    "BARRETTE",
    "BRACELET",
    "BROSSE",
    "CANAPE",
    "CHEVEU",
    "CHIFFON",
    "COFFRE",
    "COFFRET",
    "COLLIER",
    "COUETTE",
    "COUSSIN",
    "FAUTEUIL",
    "REPASSER",
    "FRANGE",
    "MENAGE",
    "OREILLER",
    "PARFUM",
    "PEIGNE",
    "POUPEE",
    "POUSSETTE",
    "POUSSIERE",
    "SHAMPOING",
    "SOURCIL",
    "TRESOR",
    "COIFFER",
    "HESITER",
    "PASSER",
    "PREFERER",
    "SECOUER",
    "COQUET",
    "DOUILLET",
    "FAMILLE",
    "ADULTE",
    "BAISER",
    "BAVOIR",
    "BIBERON",
    "CAPRICE",
    "CIMETIERE",
    "COUSIN",
    "COUSINE",
    "CRECHE",
    "JUMEAU",
    "MARIAGE",
    "PARENT",
    "RASOIR",
    "BERCER",
    "BLOTTIR",
    "CONSOLER",
    "DEMENAGER",
    "DETESTER",
    "MARIER",
    "OFFRIR",
    "PENSER",
    "RAPPELER",
    "RONFLER",
    "TRICOTER",
    "MALADIE",
    "AMBULANCE",
    "DENTISTE",
    "DOCTEUR",
    "FIEVRE",
    "INFIRMIER",
    "MEDECIN",
    "MENTON",
    "PANSEMENT",
    "PIQURE",
    "POISON",
    "SQUELETTE",
    "BLESSER",
    "DEVOIR",
    "ETERNUER",
    "GUERIR",
    "MOUCHER",
    "RECOUDRE",
    "SOUFFRIR",
    "TOUSSER",
    "TREMBLER",
    "ARAIGNEE",
    "BROUETTE",
    "CHENILLE",
    "FOURMI",
    "JONQUILLE",
    "LEZARD",
    "RANGEE",
    "RATEAU",
    "SOURIS",
    "TERRAIN",
    "TERRIER",
    "CUEILLIR",
    "JARDINER",
    "PLANTER",
    "PROFOND",
    "SORTIES",
    "PORTIERE",
    "VOYAGER",
    "BILLET",
    "GRIMACE",
    "GROTTE",
    "REGARD",
    "TICKET",
    "BUISSON",
    "CHASSEUR",
    "CHATAIGNE",
    "CHEMIN",
    "CORBEAU",
    "ECORCE",
    "GOURDE",
    "MARRON",
    "MOUSTIQUE",
    "MUGUET",
    "PAYSAGE",
    "ROCHER",
    "SOMMET",
    "CAMPER",
    "CHASSER",
    "GRILLER",
    "GUETTER",
    "REVOIR",
    "ADRESSE",
    "ASCENSEUR",
    "BALCON",
    "BOUCHERIE",
    "BOULANGER",
    "BOUTIQUE",
    "CANIVEAU",
    "CARAVANE",
    "CARREFOUR",
    "CINEMA",
    "CIRQUE",
    "CLOCHE",
    "CLOCHER",
    "COIFFEUR",
    "COURRIER",
    "EGLISE",
    "ENDROIT",
    "ESSENCE",
    "FACTEUR",
    "FLEURISTE",
    "HOPITAL",
    "IMMEUBLE",
    "INCENDIE",
    "LAISSE",
    "MAGASIN",
    "MANEGE",
    "MOINEAU",
    "MONUMENT",
    "OUVRIER",
    "PALAIS",
    "PANNEAU",
    "PAQUET",
    "PASSAGE",
    "PHARMACIE",
    "PISCINE",
    "POLICE",
    "POLICIER",
    "POMPIER",
    "PROMENADE",
    "SQUARE",
    "TIMBRE",
    "TRAVAUX",
    "VILLAGE",
    "VOISIN",
    "BARRER",
    "CLIGNOTER",
    "CROISER",
    "RETROUVER",
    "SALUER",
    "SAVOIR",
    "VISITER",
    "IMPORTANT",
    "PRUDENT",
    "ABRICOT",
    "ALIMENT",
    "ANANAS",
    "BANANE",
    "BIFTECK",
    "CAROTTE",
    "CERISE",
    "CHOCOLAT",
    "CITRON",
    "CONCOMBRE",
    "CORBEILLE",
    "CREVETTE",
    "ENDIVE",
    "FARINE",
    "FRAISE",
    "FRAMBOISE",
    "FROMAGE",
    "HARICOT",
    "MARCHAND",
    "MONNAIE",
    "NOISETTE",
    "OIGNON",
    "ORANGE",
    "PANIER",
    "PERSIL",
    "POIREAU",
    "RAISIN",
    "TOMATE",
    "VIANDE",
    "ACHETER",
    "AJOUTER",
    "COUTER",
    "RENDRE",
    "VENDRE",
    "BALEINE",
    "JUMELLES",
    "MOUETTE",
    "NAVIRE",
    "PECHEUR",
    "SARDINE"
]
